// export const baseUrl = "http://www.learninghell.com:81/api/";
export const baseUrl = process.env.REACT_APP_API_URL
export const rootBaseUrl = process.env.REACT_APP_API_BASE   